<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="localVisible"
      width="50%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="handleClose"
    >
      <el-form :rules="rules"  ref="form" size="mini" :model="form" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="12">
             <el-form-item label="姓名" >
             <el-input  v-model="form.realname"></el-input>
             </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="昵称" >
              <el-input  v-model="form.nickname"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="手机号" >
              <el-input  v-model="form.user_name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="密码" >
              <el-input  v-model="form.password"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="用户等级" >
              <el-select
                v-model="form.user_rank"
                style="width: 180px;"
                placeholder="请选择用户等级"
              >
                <el-option
                  v-for="item in rankList"
                  :key="item.rank_id"
                  :label="item.rank_name"
                  :value="item.rank_id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="推荐人">
              <el-input  placeholder="请选择推荐人" :disabled="true" :readonly="true"  @click.native="showUser"   v-model="form.parent_name" type="text">
                <i slot="suffix" class="el-icon-more"></i>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="onSubmit('form')">确定</el-button>
        <el-button size="small" @click="handleClose">取消</el-button>
      </div>
    </el-dialog>

    <eUserList
      :formData="formData1"
      :visible.sync="visible1"
      :title="title1"
      :closeForm="closeForm1"
    />

  </div>

</template>
<script>
  import eUserList from "./eUserList.vue";
  import moment from "moment";
  export default {
    name:'eUserForm',
    props: {
      visible: {
        type: Boolean,
        default: true,
      },
      formData: {
        type: Object,
        default: null,
      },
      title: {
        type: String,
        default: "",
      },
      closeForm: Function,
    },
    components: { eUserList },
    data(){
      return {
        localVisible:false,
        rankList:[],
        form:{
          realname:'',
          nickname:'',
          user_rank:'',
          sku_id:'',
          batch:'',
          price:0,
          name:'',
          num:0,
          is_type:'0',
          coin:0,
          money:0,
          remark:"",
          password:'',
          parent_name:'',
          parent_id:''
        },
        formData1:{},
        title1:'',
        visible1:false,

        formData2:{},
        title2:'',
        visible2:false,


        rules: {
          title: [
            { required: true, message: "请输入标题", trigger: "blur" },
            { min: 2, max: 30, message: "请控制在2-30个字符", trigger: "blur" },
          ]
        },
        curShop:'',
        employee_id:'',
        name_cn:'',

        keywords:'',
        fileList:[],
        unitList:[],
        skuList:[],
        mouldList:[],
        mList:[],
        pageNum:1,
        pageSize:10
      }
    },
    mounted() {
      ///this.getList();
      this.getRankList();
      this.batch=moment().format("YYMMDD");
    },
    methods:{
      closeForm1(){
        this.title1="";
        this.visible1=false;
        this.form.parent_id=this.formData1.parent_id;
        this.form.parent_name=this.formData1.parent_name;
      },
      showUser(){
       this.title1='选择用户';
       this.visible1=true;
      },
      getRankList(){
        let _this=this;
        const param = {
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id')
        }
        this.$axios.userRankList(param).then(res=>{
          if(res.code == 200){
            _this.rankList = res.data
          }
        }).catch(error=>{
          console.log(error);
        })
      },



      // 关闭
      handleClose() {
        this.closeForm();
      },
      // 前置提交
      onSubmit() {
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          user_id: this.formData.user_id,
          user_rank: this.form.user_rank,
          realname: this.form.realname,
          nickname: this.form.nickname,
          user_name: this.form.user_name,
          parent_id: this.form.parent_id,
          password: this.form.password,
          operator_id: sessionStorage.getItem('employee_id'),
        }
       this.$axios.mallUserSave(param).then(res=>{
          if(res.code == 200){
            this.$message({
              message:'保存成功！',
              type:'success',
              offset:225,
              duration:4000,
              onClose:()=>{

              }
            });
          }
        }).catch(error=>{
          console.log(error);
        })
        this.closeForm();

      },
      submit() {
        // let param={
        //   appid:this.formData.appid,
        //   private_key:this.formData.private_key,
        //   public_key:this.formData.public_key,
        // }

      },
      getList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }
        this.$axios.employeeList(param).then(res=>{
          if(res.code == 200){
            this.mList = res.data.data
            this.total = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      clickChange(row){
        this.employee_id=row.id;
        this.name_cn=row.name_cn;
      },
      handleBeforeUpload(){

      },
      uploadSuccess(){

      },
      uploadFile(){

      },
      chooseItem(){

      }
    },
    // 监听
    watch: {
      visible(val) {
        this.localVisible=val;
        if (val) {

          this.form.realname=this.formData.realname;
          this.form.nickname=this.formData.nickname;
          this.form.user_rank=this.formData.user_rank.rank_id;

          this.form.user_name=this.formData.user_name;
          this.form.parent_id=this.formData.parent_id;
          this.form.parent_name=this.formData.parent_name;
          // if (this.formData.img) {
          //   console.log(this.formData, " this.formData");
          //   this.formData.img = [
          //     {
          //       name: this.formData.img,
          //       url: this.formData.img,
          //     },
          //   ];
          // }
        }
      },
    },
    computed: {

    },
  }
</script>
<style lang="less" scoped>
  //https://www.yzktw.com.cn/post/1262748.html
  .upload_group {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .upload_list {
      width: 120px;
      margin-right: 1rem;
    }

    /deep/.el-upload-dragger .el-upload__text {
      font-size: 10px;
      color: #409EFF;
    }

    /deep/.el-icon-upload:before {
      width: 40px !important;
      height: 40px !important;
    }

    .upload_list:last-child {
      margin-right: 0;
    }

    /deep/.el-upload-dragger {
      width: 100%;
      height: auto;
      padding: 20px 0;
      border: 1px solid #999;
    }

    /deep/.el-upload {
      width: 100%;
    }

    /deep/.el-upload-dragger .el-icon-upload {
      margin: 10px 0;
    }
  }
  .table_name:hover{
    color: #409EFF;
    cursor: pointer;
  }
</style>
